import { FormGroup, Label, Input, Col } from "reactstrap";
import { Form } from "react-bootstrap";
import PropsType from "prop-types";

const CustomFormGroupWithSwitch = (props) => {
  const {
    label,
    inputName,
    switchName,
    onChange,
    onSwitchChange,
    type,
    value,
    switchValue,
    placeholder,
    disabled,
    className,
  } = props;

  return (
    <FormGroup row className="align-items-center">
      <Label sm={4} md={2} className="text-center">
        {label}
      </Label>
      <Col sm={5} md={7}>
        <Input
          name={inputName}
          onChange={onChange}
          type={type}
          value={value}
          placeholder={placeholder}
          disabled={disabled}
          className={className}
        />
      </Col>
      <Col sm={3} md={3} className="d-flex align-items-center">
        <span className="me-2">Active:</span>
        <Form.Switch
          name={switchName}
          onChange={onSwitchChange}
          checked={switchValue}
        />
      </Col>
    </FormGroup>
  );
};

CustomFormGroupWithSwitch.propTypes = {
  onChange: PropsType.func.isRequired,
  onSwitchChange: PropsType.func.isRequired,
  type: PropsType.string.isRequired,
  inputName: PropsType.string.isRequired,
  switchName: PropsType.string.isRequired,
};

export default CustomFormGroupWithSwitch;
